import React from "react";

//
import { Card, Col } from "react-bootstrap";

//
import ChangePasswordModal from './ChangePasswordModal'

function ChangePassword() {
  return (
    <Col md={6} className="change-password security-item gutter-b">
      <Card className="bordered">
        <Card.Body>
          <header >
            <h5>Would you like to change your password? 🔑</h5>
          </header>

          <footer>
            <a className="text-info fw-bolder">Forgot Password?</a>

            <ChangePasswordModal/>
          </footer>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default ChangePassword;
